'use strict';

import { AdminWebCore } from '@peoplepower/webcore-admin';

/**
 * Let's just expose outside the Webcore factory, so we can build local services depending on it.
 */
export default angular
  .module('maestro.services.webcore', [
    'maestro.services.config'
  ])

  .provider('webcore', function(configProvider) {
    const webCoreInstance = new AdminWebCore('prod', {
      localStoragePrefix: configProvider.getConfigByKey('environment.localStorageItemPrefix'),
      signInBySignature: {
        enabled: true,
        allowProduction: false,
      },
    });

    this.getWebCore = () => {
      return webCoreInstance;
    };

    this.$get = () => webCoreInstance;

  })

  .name;
